<div class="">
    <div class="row clearfix">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card">
                <!-- Search filters -->

                <!-- Main table -->
                <div class="body table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th># <i class="fa fa-redo" (click)="getItems()"></i>
                                </th>
                                <th>Matricule</th>
                                <th>Nom prenom</th>
                                <th>Libellé réseau</th>
                                <th>Nombre prestataires</th>
                                <th>Photo</th>

                                <!-- <th style="text-align: center;">Actions</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of items; let i=index">
                                <!-- Main item row -->
                                <tr [class.expanded]="item.expanded" class="expandable-row">
                                    <td class="expand-btn-cell">
                                        <button mat-icon-button (click)="toggleFactureRow(item)" class="expand-btn">
                                            <app-feather-icons [icon]="item.expanded ? 'chevron-down' : 'chevron-right'"
                                                [class]="'expand-icon'">
                                            </app-feather-icons>
                                        </button>
                                    </td>
                                    <td>{{ item.matricule }}</td>
                                    <td>{{ item.nom+' '+item.prenom }}</td>
                                    <td>{{ item.reseau_de_soin_libelle }}
                                    <td>{{ item.nombre_prestataire | integerFormat}}
                                    </td>
                                    <td>
                                        <img [src]="item.beneficiaire_image_url | safe" (error)="handleImageError(item)"
                                            style="width: 30px; height: 30px; display: block; border-radius: 50px;" />
                                    </td>


                                    <!-- <td><span class="money-amount">{{ item.montant_accorde | integerFormat }}</span></td> -->
                                    <!-- <td>{{ item.created_by }}</td> -->
                                    <!-- <td><a *ngIf="item.ged_file_url" href="{{item.ged_file_url}}" download target="_blank">Fichier</a></td> -->
                                    <!-- <td style="text-align: center;">

                                        
                                    </td> -->
                                </tr>

                                <!-- Factures subtable (level 1) -->
                                <tr *ngIf="item.expanded" class="subtable-row">
                                    <td colspan="9">
                                        <div class="subtable-wrapper">
                                            <h6 class="subtable-title">
                                                <i class="fa fa-file-invoice"></i>
                                                Prestataire
                                                <!-- <input [(ngModel)]="searchKey"
                                                    class="form-control custom-input pull-left"
                                                    placeholder="Rechercher ..."
                                                    (keyup)="currentPage = 0; getItemsPrestataireReseauDesoin()" /> -->
                                            </h6>
                                            <table class="table table-sm subtable">
                                                <thead>
                                                    <tr>
                                                        <th># <i class="fa fa-redo"
                                                                (click)="getItemsPrestataireReseauDesoin(item)"></i>
                                                        </th>
                                                        <th>Libellé</th>
                                                        <th>Date effet</th>
                                                        <th>Date fin</th>
                                                        <!-- <th>Option</th> -->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container
                                                        *ngFor="let presta of itemPrestataireReseauDesoin; let j=index">
                                                        <!-- Facture row -->
                                                        <tr class="expandable-row">
                                                            <td style="width: 2px;"></td>
                                                        
                                                            <td>{{ presta.prestataire_libelle
                                                                }}</td>
                                                            <td>
                                                                <span class="type-badge">{{
                                                                    ((presta.date_effet||1) | dateFormat)
                                                                    }}</span>
                                                            </td>

                                                            <td><span class="money-amount">{{
                                                                    presta.date_fin |
                                                                    dateFormat
                                                                    }}</span></td>

                                                        </tr>

                                                    </ng-container>

                                                  <tr>
                                                      <td colspan="5">
                                                        <mat-paginator #paginator [length]="totalItems" [pageIndex]="0"
                                                        [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"
                                                        (page)="onPageChange($event)">
                                                    </mat-paginator>
                                                      </td>
                                                  </tr>

                                                    <!-- Empty state for factures -->
                                                    <tr
                                                        *ngIf="!itemPrestataireReseauDesoin || itemPrestataireReseauDesoin.length === 0">
                                                        <td colspan="6" class="text-center text-muted">
                                                            <i class="fa fa-info-circle"></i>
                                                            Aucune donnée trouvée
                                                            pour
                                                            cet élément
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>

                            <!-- Empty state for main items -->
                            <tr *ngIf="!items || items.length === 0">
                                <td colspan="12" class="text-center text-muted">
                                    <div class="empty-state">
                                        <i class="fa fa-search fa-2x"></i>
                                        <h5>Aucun résultat trouvé</h5>
                                        <p>Veuillez ajuster vos critères de recherche
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                </div>
            </div>
        </div>
    </div>